export default __webpack_public_path__ + "static/media/char.61f0a606.jpg";